import { useState } from "react";

import { Dialog, Button } from "@material-ui/core";

import { SubImage } from "./style/news";
import {
  GridContainer,
  FirstContainer,
  SecondContainer,
} from "./style/gridPics";

export default ({ subImages }: { subImages: { url: string }[] }) => {
  const createGrid = () => {
    const result = [];
    for (let i = 0; i < subImages.length; i++) {
      if (i % 2 === 1) continue;

      const first = subImages[i];
      const second = subImages[i + 1];

      result.push(
        <GridContainer>
          <FirstContainer>
            <Button style={{ padding: 0 }} aria-label="first image">
              <SubImage
                src={first.url}
                alt={first.url}
                onContextMenu={(e) => {
                  e.preventDefault();
                  return false;
                }}
                onClick={() => openDialog(first.url)}
              />
            </Button>
          </FirstContainer>
          {second && (
            <SecondContainer>
              <Button style={{ padding: 0 }} aria-label="second image">
                <SubImage
                  src={second.url}
                  alt={second.url}
                  onContextMenu={(e) => {
                    e.preventDefault();
                    return false;
                  }}
                  onClick={() => openDialog(second.url)}
                />
              </Button>
            </SecondContainer>
          )}
        </GridContainer>
      );
    }

    return result;
  };

  const [open, setOpen] = useState(false);
  const [modalImg, setModalImg] = useState("");
  const [selected, setSelected] = useState("");
  const openDialog = (img: string) => {
    setOpen(true);
    setModalImg(img);
  };
  const handleClose = () => {
    setOpen(false);
    setModalImg("");
    setSelected(selected);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="profile_pic"
        maxWidth="lg"
      >
        <img
          src={modalImg}
          alt="modal"
          onContextMenu={(e) => {
            e.preventDefault();
            return false;
          }}
          style={{
            objectFit: "contain",
            width: "100%",
          }}
        />
      </Dialog>
      {createGrid()}
    </>
  );
};
